var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66663 1.41663V2.47913M11.3333 1.41663V2.47913M2.47913 6.43871H14.5208",
    stroke: "#F45600",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 15.5833H5.66667C3.1875 15.5833 2.125 14.1666 2.125 12.0416V6.02079C2.125 3.89579 3.1875 2.47913 5.66667 2.47913H11.3333C13.8125 2.47913 14.875 3.89579 14.875 6.02079C14.875 6.02079 14.875 10.9791 14.875 12.0416",
    stroke: "#F45600",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49642 9.70422H8.5035M5.87488 9.70422H5.88196M5.87488 11.8292H5.88196",
    stroke: "#F45600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6245846e939a5c26d597aec4ec079e55.svg";
export { ForwardRef as ReactComponent };